export type DemoRoleId =
  | "ROLE-EMPLOYEE"
  | "ROLE-PROJECT-MANAGER"
  | "ROLE-SUPERVISOR"
  | "ROLE-DIRECTOR"
  | "ROLE-VP"
  | "ROLE-FINANCE-ACCOUNTING"
  | "ROLE-AP-PROCUREMENT-INVENTORY"
  | "ROLE-CONTRACTS-SUBCONTRACTS"
  | "ROLE-HR"
  | "ROLE-VP-HR"
  | "ROLE-HR-ANALYST"
  | "ROLE-CGO"
  | "ROLE-BP-REQUESTER"
  | "ROLE-PAYROLL"
  | "ROLE-HR-PAYROLL"
  | "ROLE-COMPANY-ADMIN"
  | "ROLE-ADMIN-SECURITY-INTEGRATION"
  | "ROLE-EXECUTIVE-BI-AUDITOR"
  | "ROLE-GOVSUITE-SUPPORT";

export type DemoRole = {
  id: DemoRoleId;
  workbenchId: string;
  label: string;
  short: string;
  homePath: string;
  primaryModuleIds: string[];
};

export const DEMO_ROLES: DemoRole[] = [
  {
    id: "ROLE-EMPLOYEE",
    workbenchId: "WB-EMPLOYEE",
    label: "Employee",
    short: "Employee",
    homePath: "/app/workbench",
    primaryModuleIds: [
      "timekeeping",
      "expenses",
      "leave",
      "benefits",
      "payroll",
      "documents",
      "helpdesk",
      "profile",
      "org-hierarchy",
    ],
  },
  {
    id: "ROLE-PROJECT-MANAGER",
    workbenchId: "WB-PROJECT-MANAGER",
    label: "Project Manager",
    short: "PM",
    homePath: "/app/projects",
    primaryModuleIds: [
      "projects",
      "planning",
      "timekeeping",
      "charge-codes",
      "contracts",
      "org-hierarchy",
      "documents",
      "bi",
      "helpdesk",
    ],
  },
  {
    id: "ROLE-SUPERVISOR",
    workbenchId: "WB-SUPERVISOR",
    label: "Supervisor",
    short: "Supervisor",
    homePath: "/app/workbench",
    primaryModuleIds: [
      "timekeeping",
      "expenses",
      "leave",
      "benefits",
      "documents",
      "helpdesk",
      "profile",
      "org-hierarchy",
    ],
  },
  {
    id: "ROLE-DIRECTOR",
    workbenchId: "WB-DIRECTOR",
    label: "Director",
    short: "Director",
    homePath: "/app/portfolio",
    primaryModuleIds: [
      "portfolio",
      "contracts",
      "projects",
      "planning",
      "org-hierarchy",
      "bi",
      "charge-codes",
      "documents",
      "helpdesk",
    ],
  },
  {
    id: "ROLE-VP",
    workbenchId: "WB-VP",
    label: "VP (Delivery)",
    short: "VP",
    homePath: "/app/portfolio",
    primaryModuleIds: [
      "portfolio",
      "contracts",
      "projects",
      "planning",
      "org-hierarchy",
      "bi",
      "charge-codes",
      "documents",
      "helpdesk",
    ],
  },
  {
    id: "ROLE-FINANCE-ACCOUNTING",
    workbenchId: "WB-FINANCE-CONTROLLER",
    label: "Finance / Accounting",
    short: "Finance",
    homePath: "/app/gl",
    primaryModuleIds: [
      "gl",
      "billing",
      "labor",
      "dcaa",
      "planning",
      "bi",
      "company",
      "timekeeping",
      "charge-codes",
      "helpdesk",
    ],
  },
  {
    id: "ROLE-AP-PROCUREMENT-INVENTORY",
    workbenchId: "WB-AP-PROCUREMENT",
    label: "AP / Procurement / Inventory",
    short: "AP / Proc",
    homePath: "/app/procurement",
    primaryModuleIds: ["ap", "procurement", "inventory", "manufacturing", "documents", "helpdesk"],
  },
  {
    id: "ROLE-CONTRACTS-SUBCONTRACTS",
    workbenchId: "WB-CONTRACTS-SUBCONTRACTS",
    label: "Contracts / Subcontracts",
    short: "Contracts",
    homePath: "/app/contracts",
    primaryModuleIds: [
      "contracts",
      "subcontracts",
      "billing",
      "charge-codes",
      "org-hierarchy",
      "documents",
      "bi",
      "dcaa",
      "helpdesk",
    ],
  },
  {
    id: "ROLE-HR",
    workbenchId: "WB-HR",
    label: "HR",
    short: "HR",
    homePath: "/app/hr",
    primaryModuleIds: [
      "hr",
      "leave",
      "benefits",
      "company",
      "org-hierarchy",
      "charge-codes",
      "documents",
      "helpdesk",
    ],
  },
  {
    id: "ROLE-VP-HR",
    workbenchId: "WB-VP-HR",
    label: "VP HR",
    short: "VP HR",
    homePath: "/app/charge-codes",
    primaryModuleIds: [
      "charge-codes",
      "leave",
      "hr",
      "company",
      "org-hierarchy",
      "documents",
      "helpdesk",
    ],
  },
  {
    id: "ROLE-HR-ANALYST",
    workbenchId: "WB-HR-ANALYST",
    label: "HR Analyst",
    short: "HR Analyst",
    homePath: "/app/charge-codes",
    primaryModuleIds: ["charge-codes", "leave", "hr", "documents", "helpdesk"],
  },
  {
    id: "ROLE-CGO",
    workbenchId: "WB-CGO",
    label: "Chief Growth Officer",
    short: "CGO",
    homePath: "/app/charge-codes",
    primaryModuleIds: ["charge-codes", "bi", "planning", "documents", "helpdesk"],
  },
  {
    id: "ROLE-BP-REQUESTER",
    workbenchId: "WB-BP-REQUESTER",
    label: "B&P Requester",
    short: "B&P Req",
    homePath: "/app/charge-codes",
    primaryModuleIds: ["charge-codes", "documents", "helpdesk"],
  },
  {
    id: "ROLE-PAYROLL",
    workbenchId: "WB-PAYROLL",
    label: "Payroll",
    short: "Payroll",
    homePath: "/app/payroll",
    primaryModuleIds: ["payroll", "timekeeping", "labor", "company", "documents", "helpdesk"],
  },
  {
    id: "ROLE-HR-PAYROLL",
    workbenchId: "WB-HR-PAYROLL",
    label: "HR / Payroll (deprecated)",
    short: "HR+Pay",
    homePath: "/app/hr",
    primaryModuleIds: ["hr", "leave", "benefits", "payroll", "labor", "company", "timekeeping", "documents", "helpdesk"],
  },
  {
    id: "ROLE-COMPANY-ADMIN",
    workbenchId: "WB-COMPANY-ADMIN",
    label: "Company Admin",
    short: "Co Admin",
    homePath: "/app/company-admin",
    primaryModuleIds: ["company-admin", "company", "timekeeping", "leave", "documents", "dcaa", "helpdesk"],
  },
  {
    id: "ROLE-ADMIN-SECURITY-INTEGRATION",
    workbenchId: "WB-ADMIN-SECURITY",
    label: "Admin / Security / Integration",
    short: "Security",
    homePath: "/app/platform",
    primaryModuleIds: ["platform", "integrations", "charge-codes", "documents", "bi", "helpdesk"],
  },
  {
    id: "ROLE-EXECUTIVE-BI-AUDITOR",
    workbenchId: "WB-EXECUTIVE-BI-AUDITOR",
    label: "Executive / BI / Auditor",
    short: "Executive",
    homePath: "/app/bi",
    primaryModuleIds: ["bi", "planning", "billing", "contracts", "gl", "platform", "timekeeping", "labor", "dcaa", "helpdesk"],
  },
  {
    id: "ROLE-GOVSUITE-SUPPORT",
    workbenchId: "WB-GOVSUITE-SUPPORT",
    label: "GovSuite Support",
    short: "GS Support",
    homePath: "/app/helpdesk",
    primaryModuleIds: ["helpdesk", "platform"],
  },
];

/** Roles selectable only when session email is @govsuite.com. */
export const GOVSUITE_ONLY_ROLES: DemoRoleId[] = ["ROLE-GOVSUITE-SUPPORT"];

export function rolesVisibleForEmail(email: string | null | undefined): DemoRole[] {
  const ok = (email || "").toLowerCase().trim().endsWith("@govsuite.com");
  return DEMO_ROLES.filter((r) => ok || !GOVSUITE_ONLY_ROLES.includes(r.id));
}

const ROLE_SET = new Set(DEMO_ROLES.map((r) => r.id));

export function roleById(id: string): DemoRole {
  return DEMO_ROLES.find((r) => r.id === id) ?? DEMO_ROLES[0];
}

export function rolesByIds(ids: string[]): DemoRole[] {
  const seen = new Set<string>();
  const out: DemoRole[] = [];
  for (const id of ids) {
    if (!ROLE_SET.has(id as DemoRoleId) || seen.has(id)) continue;
    seen.add(id);
    out.push(roleById(id));
  }
  return out.length ? out : [DEMO_ROLES[0]];
}

export function unionModuleIds(roles: DemoRole[]): string[] {
  const ids = new Set<string>();
  for (const r of roles) for (const m of r.primaryModuleIds) ids.add(m);
  return [...ids];
}

export function homePathForRoles(roles: DemoRole[]): string {
  return roles[0]?.homePath ?? "/app/timekeeping";
}

export function formatRoleSummary(roles: DemoRole[]): string {
  if (roles.length === 1) return roles[0].short;
  return roles.map((r) => r.short).join(" + ");
}

export function normalizeStoredRoleIds(raw: string | null): DemoRoleId[] {
  if (!raw) return ["ROLE-EMPLOYEE"];
  try {
    const parsed = JSON.parse(raw) as unknown;
    if (Array.isArray(parsed)) {
      const ids = parsed.filter(
        (x): x is DemoRoleId => typeof x === "string" && ROLE_SET.has(x as DemoRoleId),
      );
      return ids.length ? ids : ["ROLE-EMPLOYEE"];
    }
  } catch {
    /* single id */
  }
  if (raw === "ROLE-PM-SUPERVISOR") return ["ROLE-PROJECT-MANAGER", "ROLE-SUPERVISOR"];
  if (raw === "ROLE-HR-PAYROLL") return ["ROLE-HR", "ROLE-PAYROLL"];
  if (ROLE_SET.has(raw as DemoRoleId)) return [raw as DemoRoleId];
  return ["ROLE-EMPLOYEE"];
}

/** Demo signed-in employee identity used for own-record filtering. */
export const DEMO_EMPLOYEE = {
  id: "emp-chen",
  name: "Avery Chen",
  email: "avery.chen@harborfs.example",
};

/** Org chart for echelon compliance / leave approval. */
export const DEMO_ORG = {
  supervisors: {
    "emp-ortiz": { name: "Jordan Ortiz", reportIds: ["emp-chen", "emp-blake"] },
  } as Record<string, { name: string; reportIds: string[] }>,
  pmOverseesSupervisors: ["emp-ortiz"],
};
